
export const queryString = (name) => {
    let searchHref = window.location.href.indexOf('?') > -1 ? window.location.href.split('?')[1] : ''
    if (name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = searchHref.match(reg);//search,查询？后面的参数，并匹配正则
        if (r != null) return decodeURIComponent(r[2]);
        return null;
    } else {
        const theRequest = {};
        if (searchHref) {
            let strs = searchHref.split("&");
            for(let i = 0; i < strs.length; i ++) {
                theRequest[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    }
}
export const setQueryString = (data) => {
    let path = ''
    if (!data) return path
    return Object.keys(data).reduce((cur, key, index, arr) => {
        cur += index === 0 ? `?${key}=${data[key]}` : `&${key}=${data[key]}`
        return cur
    }, path)
}
export const scrollToTop = () => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
}
export const langPath = (path) => {
    const lang =  queryString('lang')
    return !lang ? path : (path.includes('?') ? `${path}&lang=${lang}` : `${path}?lang=${lang}`)
}
export default {
    queryString,
    scrollToTop,
    setQueryString,
    langPath
}
